import { DebtConsolidationPage } from '../../../containers/calculators/personal-finance/debt-consolidation'

export default DebtConsolidationPage

// This should work but doesn't in prod build
// https://github.com/gatsbyjs/gatsby/issues/12384
// import { default } from '../../../containers/calculators/personal-finance/debt-consolidation'
